import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Guid } from 'guid-typescript';

import { ActionElementComponent } from '../../base/action-element';
import { BaseElement } from '../../models/base-element';
import { Menu, MenuLink } from '../../models/menu';
import { Numpad } from '../../models/numpad';
import { PageRequest } from '../../models/page-request';
import { Signature } from '../../models/signature';
import { ModalService } from '../../services/modal.service';
import { StressService } from '../../services/stress.service';
import { StyleService } from '../../services/style.service';
import { NgClass } from '@angular/common';
import { SignatureCanvasComponent } from '../dynamic-elements/signature/signature-canvas.component';

@Component({
    selector: 'portal-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    imports: [NgClass],
})
export class MenuComponent extends ActionElementComponent {

  style: boolean = false;
  stress: boolean = false;
  rounds: number = 10;
  pages: string[] = ['00000000-4ad4-431b-b678-d25c7124fe37'];

  menu: Menu | null = null;

  @Output() toggleMenu = new EventEmitter<string>();

  @Input() set element(value: BaseElement) {
    this.menu = value as Menu;
  };

  constructor(
    private modalService: ModalService,
    public stressService: StressService,
    private route: ActivatedRoute,
    public styleService: StyleService
  ) {
    super();
    const rounds = this.route.snapshot.queryParamMap.get('rounds');
    if (rounds != null && rounds != undefined) {
      this.rounds = +rounds;
    }
    this.stress = !!this.route.snapshot.queryParamMap.get('stress');
    const pages = this.route.snapshot.queryParamMap.get('pages');
    if (pages) {
      this.pages = pages.split(',');
    }

    this.style = !!this.route.snapshot.queryParamMap.get('style');

  }

  override action($event: any, link: MenuLink): void {
    this.toggleMenu.emit(Guid.create().toString());
    super.action($event, link);
  }

  openSignature($event: any) {
    $event.stopPropagation();
    $event.preventDefault();
    this.modalService.openModal(SignatureCanvasComponent, {
      initialState: { signature: { pageRequests: [{} as PageRequest] } as Signature },
      ignoreBackdropClick: true,
    });
  }
  
  openNumpad($event: any) {
    $event.stopPropagation();
    $event.preventDefault();
    this.modalService.numpad({ pageRequests: [{} as PageRequest] } as Numpad);
  }

}
